import { InjectionToken } from '@angular/core';
import { DamageCategoryModel } from 'app/domain/machine-damage-reporting/data/models/damage-category.model';
import { Where } from 'app/shared/data/crud.interface';

/**
 * Repository für die Schadenskategorien
 */
export type DamageCategoryRepository
  = Where<DamageCategoryModel>;

// InjectionToken für das DamageCategoryRepository
export const DAMAGE_CATEGORY_REPOSITORY =
  new InjectionToken<DamageCategoryRepository>('DAMAGE_CATEGORY_REPOSITORY');
